import axios from '../../axios';

const path = 'dashboard';

const service = {
  fetchCounters() {
    return axios.get(`${path}/counters`);
  }
};

export default service;
